<h2>Status des connexions en temps réel avec le serveur</h2>

<app-admin-console-row *ngFor='let item of indicators'
                       [title]='item.title'
                       [error]='item.error'
                       [status]='item.status'
                       (refresh)='item.refresh'>
</app-admin-console-row>
